
import Vue from 'vue';

import { mapState } from 'pinia';
import { useStore as useShapeStore } from '@/stores/shape';
import { useStore as useProductStore } from '@/stores/product';

import OutOfBoundariesNotification from './OutOfBoundariesNotification.vue';

export default Vue.extend({
  name: 'OutOfBoundariesMonitor',

  components: {
    OutOfBoundariesNotification,
  },

  computed: {
    ...mapState(useShapeStore, ['collisionDetails', 'positionShapeMap']),
    ...mapState(useProductStore, ['selectedPrintPosition']),

    collides() {
      const collisionData = {
        data: false as boolean | undefined,
        payloadIds: [] as string[],
      };
      collisionData.data =
        this.collisionDetails &&
        !this.collisionDetails.every((c) => c.aInB === true);

      this.collisionDetails?.forEach((c) => {
        if (c.aInB === false) {
          collisionData.payloadIds.push(c.payloadId);
        }
      });
      return collisionData;
    },
  },
});
